import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-skidog/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin-skidog/dashboard' });
  },
});
